import * as React  from 'react'
import { connect } from 'react-redux'

import {
  changeLocale,
  selectLocale,
}                    from '../../redux'
import {
  SettingsDialog,
}                    from '../molecules'

export interface SettingsOpenerProps {
  open: () => void
}

interface SettingsState {
  isSettingsDialogOpen: boolean
}

interface SettingsProps {
  children: (openerProps: SettingsOpenerProps) => React.ReactNode
}

const mstp = state => ({ locale: selectLocale(state) })

class Settings extends React.Component<
  SettingsProps
  & ReturnType<typeof mstp>
  & typeof actions,
  SettingsState> {
  public state = {
    isSettingsDialogOpen: false,
  }

  public render () {
    const {
      locale,
      changeLocale,
    } = this.props

    const { isSettingsDialogOpen } = this.state

    /* typescript fix ur s**t man... */
    const childFunc = this.props.children as any

    return (
      <>
        {childFunc({ open: this.toggleSettingsDialogOpen })}
        <SettingsDialog
          changeLanguage={changeLocale}
          close={this.toggleSettingsDialogOpen}
          isOpen={isSettingsDialogOpen}
          settings={{ locale }}
        />
      </>
    )
  }

  private toggleSettingsDialogOpen = () => {
    this.setState(state => ({
      isSettingsDialogOpen: !state.isSettingsDialogOpen,
    }))
  }
}

const actions = { changeLocale }
export default connect(mstp, actions)(Settings)



// WEBPACK FOOTER //
// ./src/components/organisms/Settings.tsx